
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5G9n6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $250c87d0f9a271cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bfb59 = parcelRequire("bfb59");

var $j4I0J = parcelRequire("j4I0J");
const $250c87d0f9a271cb$var$AttachmentViewedStreamHubEvents = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        const handleAttachmentViewedEvent = (event)=>{
            if ([
                'full',
                'download'
            ].includes(event?.viewingLevel)) (0, $j4I0J.notifyAttachmentViewed)(event?.fileId);
        };
        (0, $bfb59.globalMediaEventEmitter).on('media-viewed', handleAttachmentViewedEvent);
        return ()=>{
            (0, $bfb59.globalMediaEventEmitter).off('media-viewed', handleAttachmentViewedEvent);
        };
    });
    return null;
};
var $250c87d0f9a271cb$export$2e2bcd8739ae039 = $250c87d0f9a271cb$var$AttachmentViewedStreamHubEvents;

});
parcelRegister("j4I0J", function(module, exports) {

$parcel$export(module.exports, "notifyAttachmentViewed", () => $fdfed03681264cd9$export$97d5990bba7d4ce9);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $fdfed03681264cd9$export$97d5990bba7d4ce9 = (fileId)=>{
    try {
        const url = '/rest/internal/3/analytics/attachment/viewed';
        return (0, $eusud.performPostRequest)(url, {
            body: JSON.stringify({
                fileId: fileId
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'notifyAttachmentViewed',
                packageName: 'jiraAttachmentViewedStreamhubEvents',
                teamName: 'gryffindor'
            }
        });
    }
};

});



//# sourceMappingURL=async-attachment-viewed-streamhub-events.4a9d7574.js.map
